import { useNavigate, useLocation, useParams } from "react-router-dom";
import type { ComponentType, JSX } from "react";

/**
 * Higher-Order Component that injects React Router v6 routing utilities into a component
 * @param WrappedComponent - The component to wrap with routing utilities
 * @returns A new component with routing props injected
 */
export const withRouting = <P extends object>(
  WrappedComponent: ComponentType<P & RouterProps>
): ComponentType<P> => {
  return function WithRoutingWrapper(props: P): JSX.Element {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return (
      <WrappedComponent
        {...props}
        navigate={navigate}
        location={location}
        params={params}
      />
    );
  };
};

export interface RouterProps {
  navigate: ReturnType<typeof useNavigate>;
  location: ReturnType<typeof useLocation>;
  params: Record<string, string>;
}
